import type { UIStringsOverride } from "../i18n-ui.ts";

/** Danish (da) UI strings. */
export const da: UIStringsOverride = {
  actions: {
    addToCursor: "Føj til Cursor",
    addToVscode: "Føj til VS Code",
    askAI: "Spørg AI om denne side",
    connectMcp: "Opret forbindelse til MCP",
    copied: "Kopieret!",
    copyClaudeCode: "Kopiér Claude Code-kommando",
    copyCode: "Kopiér kode",
    copyCodex: "Kopiér Codex-kommando",
    copyMarkdown: "Kopiér som Markdown",
    copyServerUrl: "Kopiér server-URL",
    edit: "Rediger på GitHub",
    export: "Eksportér",
    exportEpub: "Eksportér til EPUB",
    exportPdf: "Eksportér til PDF",
    generating: "Genererer…",
    openIn: "Åbn i {name}",
    openInChat: "Åbn i chat",
    scrollToTop: "Tilbage til toppen",
  },
  ask: {
    ai: "AI",
    clear: "Ryd samtalen",
    close: "Luk",
    copy: "Kopiér samtalen",
    empty: "Stil et spørgsmål om dokumentationen.",
    error: "Beklager, noget gik galt.",
    label: "Stil et spørgsmål",
    placeholder: "Stil et spørgsmål…",
    send: "Send",
    tip: "Tip: Du kan åbne og lukke chatten med",
    title: "Spørg AI",
    you: "Du",
  },
  banner: { dismiss: "Luk meddelelsen" },
  changelog: {
    description: "Produktopdateringer og udgivelsesnoter.",
    showReleases: "Vis udgivelser for {version}",
    title: "Ændringslog",
  },
  content: { diagramError: "Dette diagram kunne ikke vises." },
  feedback: {
    no: "Nej",
    question: "Var denne side nyttig?",
    thanks: "Tak for din feedback!",
    yes: "Ja",
  },
  languageSwitcher: { label: "Sprog", untranslated: "Ikke oversat" },
  nav: {
    back: "Tilbage",
    breadcrumb: "Brødkrummesti",
    closeNavigation: "Luk navigationen",
    deprecated: "forældet",
    featured: "Udvalgt",
    githubRepository: "GitHub-repositorium",
    navigation: "Navigation",
    primary: "Primær",
    sections: "Sektioner",
    toggleNavigation: "Vis eller skjul navigationen",
    toggleTheme: "Skift farvetema",
  },
  notFound: {
    description: "Vi kunne ikke finde den side, du leder efter.",
    home: "Tilbage til forsiden",
    title: "Siden blev ikke fundet",
  },
  page: {
    lastUpdated: "Senest opdateret den",
    next: "Næste",
    pagination: "Paginering",
    previous: "Forrige",
    skipToContent: "Spring til indhold",
  },
  search: {
    all: "Alle",
    allLanguages: "Alle sprog",
    askAi: "Spørg AI",
    askAiHint: "Få et øjeblikkeligt svar fra AI",
    button: "Søg",
    devOnly: "Søgning er tilgængelig i produktionsbygningen.",
    error: "Noget gik galt. Prøv igen.",
    label: "Søg i dokumentationen",
    navigate: "navigér",
    noResults: "Ingen resultater fundet.",
    open: "åbn",
    placeholder: "Søg i dokumentationen…",
    popular: "Populært",
    preview: "forhåndsvis",
    results: "Resultater",
  },
  toc: { title: "På denne side" },
};
